import React from "react";
import {
  Input,
} from "antd";
import debounce from "lodash/debounce";

const CustomDebounceSearch = ({
  onSearch,
  placeholder = "Search",
}) => {
  const debouncedSearch = debounce((event) => onSearch(event), 500);

  const handleSearch = (event) => {
    event.persist();
    // Even though handleSearch is created on each render and executed
    // it references the same debouncedSearch that was created initially
    debouncedSearch(event);
  };

  const handleEnterPress = (event) => {
    debouncedSearch.cancel(); // Cancel the debounce search on enter
    onSearch(event);
  };

  return (
    <Input.Search
      className="PendingTable__Search"
      placeholder={placeholder}
      onPressEnter={handleEnterPress}
      onChange={handleSearch}
      onSearch={(value) => onSearch({ target: { value } })}
    />
  );
};

export default CustomDebounceSearch;
